import { QueryClient } from '@tanstack/react-query';
import { Mutations, processResponse, Queries } from '../query-client.js';
import type { WidgetConfig } from '../../store/widget.store.js';

function createWidget(widget: WidgetConfig) {
    return fetch(`/api/admin/widget`, {
        method: 'post',
        body: JSON.stringify(widget),
        headers: { 'content-type': 'application/json' },
    }).then(processResponse<{ id: string }>);
}

function updateWidget(widget: Partial<WidgetConfig>) {
    const { _id, ...rest } = widget;
    return fetch(`/api/admin/widget/${_id}`, {
        method: 'put',
        body: JSON.stringify(rest),
        headers: { 'content-type': 'application/json' },
    }).then(processResponse);
}

function deleteWidget(params: { _id: string }) {
    const { _id } = params;
    return fetch(`/api/admin/widget/${_id}`, {
        method: 'delete',
    }).then(processResponse);
}

export function addWidgetMutations(queryClient: QueryClient) {
    queryClient.setMutationDefaults([Mutations.WIDGET_CREATE], {
        mutationFn: createWidget,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [Queries.WIDGET_GET_ALL] });
        },
    });
    queryClient.setMutationDefaults([Mutations.WIDGET_UPDATE], {
        mutationFn: updateWidget,
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: [Queries.WIDGET_GET_ALL] });
            queryClient.invalidateQueries({ queryKey: [Queries.WIDGET_GET_BY_ID, variables._id] });
        },
    });
    queryClient.setMutationDefaults([Mutations.WIDGET_DELETE], {
        mutationFn: deleteWidget,
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: [Queries.WIDGET_GET_ALL] });
            queryClient.invalidateQueries({ queryKey: [Queries.WIDGET_GET_BY_ID, variables._id] });
        },
    });
}
